module.exports = __webpack_public_path__ + "img/live-casino-mob.2033ef6.gif";